import React, { PureComponent } from 'react';
import injectSheet from 'react-jss'
import cn from 'classnames'
import { connect } from 'react-redux'
import Checkbox from "../Widgets/Checkbox"
import DropDown from "../Widgets/DropDown"
import Link from '../Widgets/Link'
import {searchQueryChanged, toggleSearchDialog} from '../../actions'
import {
    getSearchLoading,
    getSearchDialogIsOpen,
    getSearchQuery,
    getSearchResults,
    getTrending,
    hasMoreSearchPages,
    getTotalSearchResults,
    getIsSearchEmpty
} from "../../selectors"
import {getGlobalContent} from "../../selectors/content";
import {formatSummary} from "../../utils/search"
import SearchInput from './SearchInput'

class SearchFilter extends PureComponent {

    _onQueryInputChanged = (e) => {
        const {query, handleSearch} = this.props;
        handleSearch( {
                ...query,
                query: e.target.value
            })
    }

    _onCategoriesChanged = (values) => {
        const {query, handleSearch} = this.props;
        handleSearch( {
            ...query,
            categories: values
        });
    }

    _onTagsChanged = (values) => {
        const {query, handleSearch} = this.props;
        handleSearch( {
            ...query,
            tags: values
        });
    }

    _toggleMen = () => {
        this._toggleGender('men');
    }

    _toggleWomen = () => {
        this._toggleGender('women');
    }

    _toggleGender = (gender) => {
        const {query, handleSearch} = this.props;
        const index = query.gender.indexOf(gender);
        if( index < 0 )
            handleSearch( {
                ...query,
                gender: [...query.gender, gender]
            });
        else
            handleSearch( {
                ...query,
                gender: [
                    ...query.gender.slice(0, index),
                    ...query.gender.slice(index + 1)
                ]});
    }

    _getSummary = () => {
        const {query, loading, totalResults} = this.props;
        return formatSummary(query, loading, totalResults);
    }

    render() {
        const {global, classes, query, loading, results, hasMore, isSearchEmpty, showSeeAllResultsLink} = this.props;
        const menChecked = query.gender && query.gender.indexOf('men') >= 0;
        const womenChecked = query.gender && query.gender.indexOf('women') >= 0;
        const seeMoreUrl = {url: '/search'};

        return (<div>
                <SearchInput />
                <div className={cn(classes.filter, 'normalVerticalFlow')}>
                    <Checkbox label='Women' checked={womenChecked} onChange={this._toggleWomen} className={classes.input}/>
                    <Checkbox label='Men' checked={menChecked} onChange={this._toggleMen} className={classes.input}/>
                    <DropDown id="Categories" className={classes.input} label="Categories" selectedValues={query.categories} options={global.search.categories.map(cat => cat.name)}
                        onChange={this._onCategoriesChanged}/>
                    {global.search.tags && global.search.tags.length > 0 &&
                        <DropDown id="Tags" className={classes.input} label="Tags" selectedValues={query.tags} options={global.search.tags}
                                  onChange={this._onTagsChanged}/>}
                </div>
                <div className={classes.searchResultSummary}>
                    {results && !results.length && !isSearchEmpty && !loading && <span>{global.search.empty_results_text}</span>}
                    {results && results.length > 0 && <div className={classes.summary}>
                        <span className={classes.filterSummary} dangerouslySetInnerHTML={{__html: this._getSummary()}}></span>
                        {hasMore && showSeeAllResultsLink && <Link link={seeMoreUrl}>See All Results</Link>}
                    </div>}
                </div>
            </div>)

    }
}

const mapStateToProps = (state) => {
    return {
        global: getGlobalContent(state),
        loading: getSearchLoading(state),
        query: getSearchQuery(state),
        open: getSearchDialogIsOpen(state),
        results: getSearchResults(state),
        trending: getTrending(state),
        hasMore: hasMoreSearchPages(state),
        totalResults: getTotalSearchResults(state),
        isSearchEmpty: getIsSearchEmpty(state)
    }
}

function mapDispatchToProps(dispatch) {
    return {
        handleSearch: ( query ) => {
            dispatch(searchQueryChanged(query))
        },
        handleCloseDialog: () => {
            dispatch(toggleSearchDialog())
        },
    }
}

export default injectSheet((theme) => ({
    filter: {
        display: 'flex',
        marginLeft: 0,
        marginRight: 0,
        [theme.breakpoint('tablet')]: {
            marginLeft: -10,
            marginRight: -10,
        },
        flexWrap: 'wrap',
        "& > div": {
            flexBasis: '50%',
            [theme.breakpoint('tablet')]: {
                margin: '0 10px',
                flexBasis: 'auto'
            },
        }
    },
    searchResultSummary: {
        ...theme.font.title.h4,
        paddingLeft: theme.spacing.tiny,
    },
    summary: {
        display: 'flex',
        color: theme.colors.assent,
        '& strong': {
            color: theme.colors.black,
        },
        '& span': {
            flexGrow: 1,
            display: 'none',
            [theme.breakpoint('tablet')]: {
               display: 'block',
           }
        }
    },
    filterSummary: {
        paddingLeft: theme.spacing.tiny,
        "& span": {
            color: theme.colors.black,
            display: 'inline-block'
        }
    },
    input: {
        padding: theme.spacing.tiny,
    }
}))( connect(mapStateToProps, mapDispatchToProps)(SearchFilter) );



// WEBPACK FOOTER //
// ./src/components/Search/SearchFilter.js